<template>
  <v-card rounded>
    <v-card-title>
      <v-row no-gutters>
        <div>{{ $t('button-commodity-delete') }}</div>
        <v-spacer />
        <div class="">
          <v-btn
            :disabled="isLoading"
            text
            class="mr-2"
            @click="onCloseDialog"
            >{{ $t('button-close') }}</v-btn
          >
          <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            color="error"
            @click="onDeleteCommodity"
            >{{ $t('button-delete') }}</v-btn
          >
        </div>
      </v-row>
    </v-card-title>

    <v-card-text class="pb-6 pt-2">
      {{ $t('text-commodity-delete-warn') }}
    </v-card-text>
  </v-card>
</template>

<script>
import PortPicker from '@/components/shared/local/vpl/PortPicker.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import CustomerServicePicker from '@/components/shared/local/vpl/CustomerServicePicker.vue';

export default {
  components: { PortPicker, CustomerServicePicker },
  props: {
    item: {
      type: Object,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapState('vsl/quotation', ['myQuotationCommodityList']),
  },
  async created() {},
  watch: {},
  methods: {
    ...mapActions('vsl/quotation', ['calculateMyQuotationCommodityPrices']),
    onCloseDialog() {
      this.$emit('close-dialog');
    },
    async onDeleteCommodity() {
      try {
        this.isLoading = true;
        const payload = this.myQuotationCommodityList.filter((commodity) => {
          if (commodity.id === this.item.id) {
            commodity.isDeleted = true;
          }
          return commodity;
        });
        await this.calculateMyQuotationCommodityPrices(payload);
        this.$emit('close-dialog');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
